import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import { toast } from "react-toastify";
import styles from "./savedFiltersModal.module.css";
import { useInstitution } from "../../../context/InstitutionContext";
import { getSavedFilters } from "../../../services/finance";
import loadingGif from "../../../assets/loading.gif";
import CloseIcon from "../../../assets/icons/circle-xmark.svg";
import CalendarIcon from "../../../assets/icons/calendar.svg";
import UserIcon from "../../../assets/icons/user.svg";

const SavedFiltersModal = ({ onClose, onApplyFilter, filterSource = null, onCreateFilter = null }) => {
  const { institution } = useInstitution();
  const [filters, setFilters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);

  useEffect(() => {
    // Buscar filtros apenas uma vez quando o modal abre
    const fetchSavedFilters = async () => {
      if (!institution?.id) return;
      
      try {
        setLoading(true);
        const data = await getSavedFilters({ institutionId: institution.id });
        
        // Filtrar por source no front-end se especificado
        let filteredData = data || [];
        
        if (filterSource) {
          console.log("Filtrando por source:", filterSource);
          console.log("Total de filtros antes da filtragem:", filteredData.length);
          
          filteredData = filteredData.filter(filter => {
            // O campo 'source' está diretamente no objeto do filtro, não dentro do filterJson
            console.log(`Filtro "${filter.name}" - source: ${filter.source}`);
            
            // Retorna APENAS filtros que tenham source igual ao filterSource especificado
            const shouldInclude = filter.source === filterSource;
            return shouldInclude;
          });
          
          console.log("Total de filtros após filtragem:", filteredData.length);
        }
        
        setFilters(filteredData);
      } catch (error) {
        console.error("Erro ao buscar filtros salvos:", error);
        toast.error("Erro ao carregar filtros salvos");
        setFilters([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Executa apenas uma vez quando o modal abre

  const handleApplyFilter = () => {
    if (!selectedFilter) {
      toast.warning("Selecione um filtro para aplicar");
      return;
    }
    onApplyFilter(selectedFilter);
    onClose();
  };

  const modalContent = (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* Cabeçalho */}
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Configurações de Exibição</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <img src={CloseIcon} alt="Fechar" />
          </button>
        </div>

        {/* Corpo do Modal */}
        <div className={styles.modalBody}>
          <h3 className={styles.sectionTitle}>Filtros Salvos</h3>
          <p className={styles.sectionDescription}>
            Selecione um filtro para aplicar na consulta
          </p>

          <div className={styles.filtersListContainer}>
            {loading ? (
              <div className={styles.loadingContainer}>
                <img src={loadingGif} alt="Carregando..." className={styles.loadingIcon} />
                <p>Carregando filtros...</p>
              </div>
            ) : filters.length > 0 ? (
              <div className={styles.filtersList}>
                {filters.map((filter, index) => (
                  <div 
                    key={filter.id || index} 
                    className={`${styles.filterCard} ${selectedFilter?.id === filter.id ? styles.filterCardSelected : ''}`}
                    onClick={() => setSelectedFilter(filter)}
                  >
                    <div className={styles.filterCardHeader}>
                      <input
                        type="radio"
                        name="selectedFilter"
                        checked={selectedFilter?.id === filter.id}
                        onChange={() => setSelectedFilter(filter)}
                        className={styles.radioInput}
                      />
                      <div className={styles.filterCardContent}>
                        <h4 className={styles.filterName}>{filter.name}</h4>
                        <p className={styles.filterDescription}>
                          {filter.description || "Sem descrição"}
                        </p>
                        <div className={styles.filterMeta}>
                          {filter.createdAt && (
                            <div className={styles.filterMetaItem}>
                              <img src={CalendarIcon} alt="Data" className={styles.metaIcon} />
                              <span>{new Date(filter.createdAt).toLocaleDateString('pt-BR')}</span>
                            </div>
                          )}
                          {filter.createdBy && (
                            <div className={styles.filterMetaItem}>
                              <img src={UserIcon} alt="Usuário" className={styles.metaIcon} />
                              <span>{filter.createdBy}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.emptyState}>
                <p>Nenhum filtro salvo encontrado</p>
              </div>
            )}
          </div>
        </div>

        {/* Rodapé */}
        <div className={styles.modalFooter}>
          <div className={styles.footerLeft}>
            {onCreateFilter && (
              <button className={styles.createFilterButton} onClick={onCreateFilter}>
                + Criar Filtro
              </button>
            )}
          </div>
          <div className={styles.footerRight}>
            <button className={styles.cancelButton} onClick={onClose}>
              Cancelar
            </button>
            <button
              className={styles.applyButton}
              onClick={handleApplyFilter}
              disabled={!selectedFilter}
            >
              Aplicar Filtro
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDom.createPortal(modalContent, document.body);
};

export default SavedFiltersModal;

